var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FFF8ED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_6998)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_6998",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.332 8H7.33203V32H31.332V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_654_6998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.332 30.75C13.402 30.75 8.58203 25.93 8.58203 20C8.58203 14.07 13.402 9.25 19.332 9.25C25.262 9.25 30.082 14.07 30.082 20C30.082 25.93 25.262 30.75 19.332 30.75ZM19.332 10.75C14.232 10.75 10.082 14.9 10.082 20C10.082 25.1 14.232 29.25 19.332 29.25C24.432 29.25 28.582 25.1 28.582 20C28.582 14.9 24.432 10.75 19.332 10.75Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3303 29.75H15.3303C14.9203 29.75 14.5803 29.41 14.5803 29C14.5803 28.59 14.9003 28.26 15.3103 28.25C13.7403 22.89 13.7403 17.11 15.3103 11.75C14.9003 11.74 14.5803 11.41 14.5803 11C14.5803 10.59 14.9203 10.25 15.3303 10.25H16.3303C16.5703 10.25 16.8003 10.37 16.9403 10.56C17.0803 10.76 17.1203 11.01 17.0403 11.24C15.1603 16.89 15.1603 23.11 17.0403 28.77C17.1203 29 17.0803 29.25 16.9403 29.45C16.8003 29.63 16.5703 29.75 16.3303 29.75Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3305 29.7507C22.2505 29.7507 22.1705 29.7407 22.0905 29.7107C21.7005 29.5807 21.4805 29.1507 21.6205 28.7607C23.5005 23.1107 23.5005 16.8907 21.6205 11.2307C21.4905 10.8407 21.7005 10.4107 22.0905 10.2807C22.4905 10.1507 22.9105 10.3607 23.0405 10.7507C25.0305 16.7107 25.0305 23.2707 23.0405 29.2207C22.9405 29.5507 22.6405 29.7507 22.3305 29.7507Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.332 25.2008C16.542 25.2008 13.762 24.8108 11.082 24.0208C11.072 24.4208 10.742 24.7508 10.332 24.7508C9.92203 24.7508 9.58203 24.4108 9.58203 24.0008V23.0008C9.58203 22.7608 9.70203 22.5308 9.89203 22.3908C10.092 22.2508 10.342 22.2108 10.572 22.2908C16.222 24.1708 22.452 24.1708 28.102 22.2908C28.332 22.2108 28.582 22.2508 28.782 22.3908C28.982 22.5308 29.092 22.7608 29.092 23.0008V24.0008C29.092 24.4108 28.752 24.7508 28.342 24.7508C27.932 24.7508 27.602 24.4308 27.592 24.0208C24.902 24.8108 22.122 25.2008 19.332 25.2008Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3318 17.7494C28.2518 17.7494 28.1718 17.7394 28.0918 17.7094C22.4418 15.8294 16.2118 15.8294 10.5618 17.7094C10.1618 17.8394 9.74181 17.6294 9.61181 17.2394C9.49181 16.8394 9.70181 16.4194 10.0918 16.2894C16.0518 14.2994 22.6118 14.2994 28.5618 16.2894C28.9518 16.4194 29.1718 16.8494 29.0318 17.2394C28.9418 17.5494 28.6418 17.7494 28.3318 17.7494Z",
    fill: "#FFB600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_6998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.f4a658a0fa8b108cf683a6105569c070.svg";
export { ForwardRef as ReactComponent };